/*
===============================================================================================================
                                 Copyright 2024-2024, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import React from 'react';
import PropTypes from 'prop-types';
import ReturnMethodCard from './return-method-card';

/**
 * Displaying available return methods
 * @param {object} props
 * @param {function} props.onSelect - Function called when a card is selected
 * @param {string} props.selectedOption - An id of the selected card
 * @param {Array<{id: string}>} props.returnOptions - A list of card's config objects
 * @param {boolean} props.editableMode - Whether or not the cards have editable mode UI elements
 * @param {boolean} props.editEnabled - Whether or not the edit mode for the cards is enabled
 * @param {boolean} props.centered - Whether or not the cards should be centered
 * @param {Function} props.onChange - A function called when a card field is updated
 * @return {JSX.Element}
 */
function InStoreReturnsBlock({
  returnOptions,
  editableMode,
  editEnabled,
  centered,
  onChange,
}) {
  return (
    <div className="store-promotions-block-wrapper">

      <div className="cards-wrapper">
        {returnOptions?.map((option) => (
          <div className="in-store-returns-card" key={option.id}>

            <ReturnMethodCard
              icon={option.icon}
              config={option}
              editableMode={editableMode}
              editEnabled={editEnabled}
              onChange={(fieldId, value) => {
                onChange({ cardId: option.id, fieldId, value });
              }}
            />

          </div>
        ))}
      </div>

      <style jsx>
        {`
          .block-title {
            text-align: center;
            margin-bottom: 24px;
            padding: 0 16px;
          }
          .cards-wrapper {
            display: flex;
            justify-content: ${centered ? 'center' : 'flex-start'};
            column-gap: 10px;
            margin-bottom: 36px;
          }
          .in-store-returns-card {
            width: 280px;
          }
          @media (max-width: 767px) {
            .cards-wrapper {
              flex-direction: column;
              align-items: center;
              row-gap: 10px;
            }
          }
        `}
      </style>
    </div>
  );
}

InStoreReturnsBlock.defaultProps = {
  editableMode: false,
  editEnabled: false,
  centered: false,
  onChange: null,
};

InStoreReturnsBlock.propTypes = {
  returnOptions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
  })).isRequired,
  editableMode: PropTypes.bool,
  editEnabled: PropTypes.bool,
  centered: PropTypes.bool,
  onChange: PropTypes.func,
};

export default InStoreReturnsBlock;
